export const REQUEST_ALL_STATISTICS = "general-statistics";
export const LOADED_STATISTICS = "loaded-statistics";

export function requestAllStatistics(payload) {
    return {
        type: REQUEST_ALL_STATISTICS,
        payload: payload
    }
}

export function loadedStatistics(payload) {
    return {
        type: LOADED_STATISTICS,
        payload: payload
    }
}


// WEBPACK FOOTER //
// ./src/actions/statistics.action.js